import React from "react";
import Main from "./UI/Main";


const App = () => {
  return <Main/>
}

export default App;
